
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Movie Making Competition</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm musical-comp section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Shoot At Sight - Movie <span> Making Competition</span></h2>
        </div>
        <div class="row">
            <div class="col-md-8">
                <div class="widget_title inner-title">
                    <h4>SHOOT AT SIGHT - MOVIE <span class="small-sm">MAKING COMPETITION</span></h4>
                </div>
                <div class="fide-chess-text">
                    <p> I Too Have a Talent is a digital platform for aspiring filmmakers of Raisoni Group of
                        Institutions to showcase their talents, compete for opportunities and give a new dimension to
                        their personality. </p>
                </div>

                <p>
                    Ability of observation in students is much higher than others. It is just a matter of identifying it
                    and using it to make something useful of it. Society in which we live and belong to, is full of
                    various topic which require an attention and corrective actions accordingly. This platform is
                    provided to explore that talent and bring those issues and topics in front of all.
                </p>
                <p>
                    Who knows, from this platform which aspiring filmmaker can connect the world, collaborate, and
                    compete for a wide range of professional opportunities.
                </p>
            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/shoot-banner.jpg"
                        alt="GHRSCF">
                </div>
            </div>
        </div>
        <div class="border-line-sm"></div>
        <div class="text-center">
            <iframe src="https://urlzs.com/xa5Ys" height="600" width="800" class="iframe-sm"></iframe>
        </div>
    </div>
</section>
